export const STEP_NAMES = ["About You", "Experience", "Availability", "Requirements", "Review"];

export const POSITIONS = [
  { value: "Photo Booth Event Staff", label: "Photo Booth Event Staff", hint: "Run the booth, hype the guests" },
  { value: "Driver / Staff", label: "Driver / Staff", hint: "Includes Event Lead & Driving" },
  { value: "Both", label: "Both", hint: "Open to either role" },
];

export const SHIRT_SIZES = ["XS", "S", "M", "L", "XL", "XXL", "3XL"];

export const AVAILABLE_DAYS = ["Weekdays", "Weekends", "Both", "Schedule changes, Just Ask Me"];

export const EVENT_TYPES = ["Weddings", "Corporate", "Trade Shows", "Nightlife", "Other"];

export const TECH_COMFORT = ["Beginner", "Comfortable", "Very Comfortable"];

export const FAMILIAR_TECH = [
  "iPads / Tablets",
  "Windows 11",
  "Cameras",
  "Printers",
  "Lighting",
  "Touchscreen software",
  "Mobile Hotspot",
];

export const TRAITS = [
  "Punctual",
  "Guest-friendly",
  "Professional demeanor",
  "Calm under pressure",
  "Team player",
  "Bubbly Personality",
];

export const LOAD_TRANSPORT = [
  "Yes — I'm basically a Tetris champion",
  "Some experience — I can hold my own",
  "Not yet, but I'm willing to learn",
  "No — please keep me away from the van",
];

export const PHYSICAL_OPTIONS = [
  "I acknowledge and can perform these duties",
  "I am unable to perform these duties.",
];

export const DRESS_CODE_OPTIONS = ["I'm ready to look the part!", "This doesn't work for me"];

export const CONFIRM_LABEL =
  "I confirm all my info is accurate. I'll hang tight while the team reviews everything and understand that if it's a match, someone will reach out soon!";

export const CONFIRM_NOTICE =
  "I understand that providing false information is grounds for disqualification. I also agree to CLiQ! Booths' processing of my data for recruitment purposes.";

export const DRESS_CODE_HINT =
  "Dress code is dress black, business casual (unless told otherwise). All staff must be dressed neat and be presentable to client. Professional and friendly interaction with guests is a must. We pride ourselves on outstanding customer service. It is a photo booth and should be fun so smiles are welcome from everyone, including staff.";

export const needsLogistics = (position) =>
  position === "Driver / Staff" || position === "Both";

export const initialData = {
  position: "",
  firstName: "",
  lastName: "",
  phone: "",
  email: "",
  address: "",
  is18: "",
  workAuth: "",
  instagram: "",
  shirtSize: "",
  driversLicense: "",
  yearsDriving: "",
  cargoVan: "",
  cargoVanOther: "",
  lift50: "",
  loadTransport: "",
  availableDays: "",
  earlyLate: "",
  earlyLateOther: "",
  nycCommute: "",
  liCommute: "",
  availabilityWindow: "",
  workedEvents: "",
  eventTypes: [],
  describeExperience: "",
  techComfort: "",
  familiarTech: [],
  aboutYou: "",
  traits: [],
  physicalAck: "",
  dressCode: "",
  whyCliq: "",
  anythingElse: "",
  confirm: false,
};

const has = (v) => typeof v === "string" && v.trim().length > 0;
const hasAny = (a) => Array.isArray(a) && a.length > 0;
const emailOk = (v) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v || "");

export function validateStep(step, d) {
  switch (step) {
    case 1:
      return (
        [d.position, d.firstName, d.lastName, d.phone, d.address, d.is18, d.workAuth, d.shirtSize].every(has) &&
        emailOk(d.email)
      );
    case 2:
      return (
        [d.workedEvents, d.techComfort, d.aboutYou].every(has) &&
        hasAny(d.eventTypes) &&
        hasAny(d.familiarTech) &&
        hasAny(d.traits)
      );
    case 3:
      return (
        [d.availableDays, d.earlyLate, d.nycCommute, d.liCommute].every(has) &&
        (d.earlyLate !== "Other" || has(d.earlyLateOther))
      );
    case 4: {
      const base = [d.physicalAck, d.dressCode].every(has);
      if (!needsLogistics(d.position)) return base;
      return (
        base &&
        [d.driversLicense, d.yearsDriving, d.cargoVan, d.lift50, d.loadTransport].every(has) &&
        (d.cargoVan !== "Other" || has(d.cargoVanOther))
      );
    }
    case 5:
      return d.confirm === true;
    default:
      return true;
  }
}

export const displayVal = (d, field) => {
  if (field === "cargoVan" && d.cargoVan === "Other") return d.cargoVanOther ? `Other: ${d.cargoVanOther}` : "Other";
  if (field === "earlyLate" && d.earlyLate === "Other") return d.earlyLateOther ? `Other: ${d.earlyLateOther}` : "Other";
  return d[field];
};
